<template>
<div>
    <template v-if="curlModeType === 'one'">
    <Row v-for="temp in data" :key="temp.index">
        <BillConditionBox :config="myConfig" :ref="temp.index" :operflag="true" :curIndex="temp.index" :valueData="temp.form" @doAction="doAction" @input="input"/>
    </Row>
    <Row v-if="myConfig.showAddBtn"  type="flex" justify="start">
        <Col span="24"   style="padding-left:10px;padding-right:27px"><Button type="default" style="background-color:#f8f8f9"  @click="doAdd" long>{{myConfig.addBtnName}}</Button> </Col>
    </Row>
    </template>
    <template v-if="curlModeType === 'two'">
        <Row  type="flex" justify="start"  align="middle" :gutter="16">
             <Col span="7" v-for="(temp,index) in data" v-if="index < 3">
                <BillConditionTwoBox :config="myConfig" :ref="temp.index" :curIndex="temp.index"  :valueData="temp.form" @input="input"/>
             </Col>
              <Col span="3" v-if="showOper && moreFlag">
                <p  @click="open" style="cursor:pointer;color:#2D8cF0;">
                    <span>展开</span><Icon  class="efuture-title-icon" style="transform: rotate(90deg)" type='ios-arrow-forward'/> 
                 </p>
             </Col>
        </Row>
        <Row v-if="!moreFlag" type="flex" justify="start"  align="middle" :gutter="16">
            <Col span="7" v-for="(temp,index) in data" v-if="index > 2">
                <BillConditionTwoBox :config="myConfig" :ref="temp.index" :curIndex="temp.index"  :valueData="temp.form" @input="input" />
             </Col>
        </Row>
        <Row v-if="!moreFlag" type="flex" justify="end"  align="middle" :gutter="16">
            <Col span="21"></Col>
            <Col span="3">
            <p  @click="packup" style="cursor:pointer;color:#2D8cF0;">
                <span>收起</span><Icon  class="efuture-title-icon" style="transform: rotate(90deg)" type='ios-arrow-forward'/> 
            </p>
            </Col>
        </Row>
    </template>
</div>
</template>

<script>
import BillConditionBox from './billconditionbox';
import BillConditionTwoBox from './billconditiontwobox';
export default {
    name:'billconditionsbox',
    components: {BillConditionBox,BillConditionTwoBox},
    data () {
        return {
            myConfig:{
                addBtnName:'新增查询条件',
                showAddBtn:true
            },
            moreFlag:true,
            showOper:true,
            data:[],
            selectorConfig:{},
            curlModeType:'one'
        };
    },
    props:{
        config: {
            type: Object,
            default () {
                return {};
            }
        },
        dictData: {
            type: Object,
            default:null
        },
        modeType:{
            type:String,
            default:'one'
        }
    },
    created() {
        this.init();
    },
    methods:{
        init () {
            this.curlModeType = this.modeType;
            this.myConfig = Object.assign({}, this.myConfig, this.config);
            if (this.dictData && this.myConfig.items) {
                this.myConfig.items.forEach(el => {
                    if (el.dictkey) {
                        if (el.data === undefined) {
                            let dictkey = el.dictkey;
                            if (el.customDictkey) {
                                dictkey = el.customDictkey;
                            }
                            if (this.dictData[dictkey]) {
                                el.data = this.dictData[dictkey];
                            }
                        }
                    }
                });
            }
            this.initData();
        },
        doAction(obj) {
            if (obj.name === 'doDel') {
                let index = this.data.findIndex(el => el.index === obj.index);
                if (index > -1) {
                    this.data.splice(index ,1);
                }
            }
        },
        input(e) {
            let index = this.data.findIndex(el => el.index === e.index);
            if (index > -1) {
                let obj = Object.assign({},this.data[index],{form:e.form});
                this.data.splice(index,1,obj);
            }
        },
        doAdd() {
            let num = this.data.length;
            let index = 'index_' + num;
            // eslint-disable-next-line no-constant-condition
            do {
                let tempIndex = this.data.findIndex(el => el.index === index);
                if (tempIndex > -1) {
                    num++;
                    index = 'index_' + num;
                } else {
                    let obj = {};
                    obj.index = index;
                    obj.form ={};
                    this.data.push(obj);
                    break;
                }
            } while (true);
        },
        initData() {
            this.data = [];
            if (this.modeType === 'one') {
                let obj = {};
                obj.index ='index_0';
                obj.form = {};
                obj.form.field = this.myConfig.items[0].name;
                this.data.push(obj); 
            } else {
                this.myConfig.items.forEach((el, index) => {
                    if (el.name) {
                        let temp = {};
                        temp.index = 'index_' + index;
                        temp.form = {};
                        temp.form.field = el.name;
                        this.data.push(temp); 
                    }
                });
                if (this.data.length > 3) {
                    this.showOper = true;
                    this.moreFlag = true;
                } else {
                    this.showOper = false;
                }
            }
        },
        clearData() {
            this.data = [];
            this.$nextTick(() => {
                this.initData();
            });
        },
        getCommomParam (obj, para) {
            let param = {};
            let config = this.myConfig.items.find(el => el.name === obj.field);
            if (config) {
                if (config.type === 'DateBox') {
                    if (!config.vtype || config.vtype === 'date') {
                        if (obj.oper === '==') {
                            let temp = {};
                            temp[obj.field] ={};
                            temp[obj.field]['>='] = obj.value +' 00:00:00';
                            let temp2 = {};
                            temp2[obj.field] ={};
                            temp2[obj.field]['<='] = obj.value +' 23:59:59';
                            let temp3 = {};
                            temp3['$and'] = [];
                            temp3['$and'].push(temp);
                            temp3['$and'].push(temp2);
                            if (para) {
                                para.push(temp3);
                            } else {
                                Object.assign(param,temp3);
                            }
                        } else if (obj.oper === '>' || obj.oper === '>=') {
                            param[obj.field] = {};
                            if (obj.oper === '>=') {
                                param[obj.field][obj.oper] =  obj.value + ' 00:00:00';
                            } else {
                                param[obj.field][obj.oper] =  obj.value + ' 23:59:59';
                            }
                        } else if  (obj.oper === '<' || obj.oper === '<='){
                            param[obj.field] = {};
                            if (obj.oper === '<=') {
                                param[obj.field][obj.oper] =  obj.value + ' 23:59:59';
                            } else {
                                param[obj.field][obj.oper] =  obj.value + ' 00:00:00';
                            }
                        } else if (obj.oper === '<>'){
                            let temp = {};
                            temp[obj.field] ={};
                            temp[obj.field]['<'] = obj.value +' 00:00:00';
                            let temp2 = {};
                            temp2[obj.field] ={};
                            temp2[obj.field]['>'] = obj.value +' 23:59:59';
                            let temp3 = {};
                            temp3['$or'] = [];
                            temp3['$or'].push(temp);
                            temp3['$or'].push(temp2);
                            if (para) {
                                para.push(temp3);
                            } else {
                                Object.assign(param,temp3);
                            }
                        }
                    } else {  
                        param[obj.field] = {};
                        if (obj.value.value !== undefined) {
                            param[obj.field][obj.oper] = obj.value.value; 
                        } else {
                            param[obj.field][obj.oper] = obj.value; 
                        }
                    }
                } else {
                    if (obj.oper === 'LIKE') {
                        param[obj.field] = {};
                        param[obj.field][obj.oper] = '%' + obj.value + '%';
                    } else  {
                        param[obj.field] = {};
                        if (obj.value.value !== undefined) {
                            param[obj.field][obj.oper] = obj.value.value; 
                        } else {
                            param[obj.field][obj.oper] = obj.value; 
                        }
                    } 
                }
                
            }
            
            if (para === undefined) {
                return param;
            } else {
                para.push(param);
            }
           
        },
        getQuerySearchParam () {
            if (this.data.length  === 0) {
                return {};
            }
            if (this.data.length  === 1) {
                if (this.data[0].form.value  || this.data[0].form.value === 0) {
                    return this.getCommomParam(this.data[0].form);
                } else {
                    return {};
                }
            }
            if (this.data.length > 1) {
                let obj = {};
                obj['$and'] = [];
                this.data.forEach(el => {
                    if (el.form.value || el.form.value === 0) {
                        this.getCommomParam(el.form, obj['$and']);
                    }
                });
                if (obj['$and'].length === 0) {
                    return {};
                }
                if (obj['$and'].length === 1) {
                    return obj['$and'][0];
                }
                if (obj['$and'].length  > 1) {
                    return obj;
                }
            }
        },
        open () {
            this.moreFlag = false;
        },
        packup (){
            this.moreFlag = true;
        },
    }
};
</script>



// WEBPACK FOOTER //
// src/components/layouttemplate/billconditionsbox.vue